import { render } from "./addInquiryPage.vue?vue&type=template&id=ba63f14c&scoped=true"
import script from "./addInquiryPage.vue?vue&type=script&lang=js"
export * from "./addInquiryPage.vue?vue&type=script&lang=js"

import "./addInquiryPage.vue?vue&type=style&index=0&id=ba63f14c&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba63f14c"]])

export default __exports__